var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6693 1.33398H3.33594C2.23327 1.33398 1.33594 2.23132 1.33594 3.33398V12.6673C1.33594 13.77 2.23327 14.6673 3.33594 14.6673H12.6693C13.7719 14.6673 14.6693 13.77 14.6693 12.6673V3.33398C14.6693 2.23132 13.7719 1.33398 12.6693 1.33398ZM6.70194 11.6426L3.7266 8.66732L4.66927 7.72465L6.6366 9.69198L11.2733 4.39332L12.2766 5.27132L6.70194 11.6426Z",
    fill: "#680DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8b08d35c5176b94492914447d4819377.svg";
export { ForwardRef as ReactComponent };